module.exports = __webpack_public_path__ + "static/media/directions.dd63f5da.svg";